import React, {useState} from "react";
import {Card} from "../../../../../components/card/card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus} from "react-icons/fa";
import projectUtils from "../../../../../utils/project-utils.js";
import {ENTITY_BO_OPTIONS} from "../utils/dispatch-form-utils.js";

const DispatchOtherOccurrences = ({values = [], onChange, disabled}) => {
    const [entity, setEntity] = useState(null);
    const [number, setNumber] = useState("");

    const add = () => {
        if (!number || !entity) {
            projectUtils.swalMessage("error", "Erro", "Tipo de BO e número devem ser preenchidos");
            return;
        }

        const value = `${entity.value}-${number}`;

        if (values.includes(value)) {
            projectUtils.swalMessage("error", "Erro", `${value} já selecionado`);
            return;
        }

        onChange([...values, value]);
        setEntity(null);
        setNumber("");
    };

    return (
        <Card>
            <Card.Header>
                <Card.Title>BO de terceiros</Card.Title>
            </Card.Header>
            <Card.Body>
                <SentryRow className="items-start">
                    <SelectComponent
                        classNameWrapper="col-span-2"
                        id="selectEntity"
                        label="Tipo de BO"
                        options={ENTITY_BO_OPTIONS}
                        value={entity}
                        isDisabled={disabled}
                        onChange={setEntity}
                    />
                    <div className="col-span-2 flex gap-2">
                        <InputForm
                            classNameWrapper="flex-1"
                            id="numberBo"
                            label="Número"
                            value={number}
                            disabled={disabled}
                            onChange={({target}) => setNumber(target.value)}
                        />
                        <Button type="button" onClick={add} disabled={disabled} title="Adicionar"><FaPlus/></Button>
                    </div>
                    <SelectComponent
                        classNameWrapper="col-span-8"
                        id="otherOccurrenceNumber"
                        label="BO de terceiros"
                        isMulti
                        wrapValues
                        isDisabled={disabled}
                        options={values.map(value => ({value, label: value}))}
                        value={values.map(value => ({value, label: value}))}
                        onChange={(selected) => onChange((selected ?? []).map(option => option.value))}
                    />
                </SentryRow>
            </Card.Body>
        </Card>
    );
};

export default DispatchOtherOccurrences;
